import { mountingKitsToChoices } from "@/features/sub-families/utils/filters.ts";
import { getEmptyConfigCode } from "@/features/sub-families/utils/smart-number.ts";
import { useTranslations } from "@/features/translations/components/translations.tsx";
import { useAppSelector } from "@/redux/store.ts";
import useCurrentProduct from "@/services/product/hooks/use-current-product.ts";
import { getMountingKits } from "@/services/product/utils/mounting-kits.ts";
import { SmartNumberDescriptor } from "@/types";

export default function useMountingKits() {
    const t = useTranslations();

    const smartNumberDescription = useAppSelector((state) => state.smartNumber.description);

    const currentProduct = useCurrentProduct();
    if (!currentProduct) return null;

    const choices = mountingKitsToChoices(getMountingKits(currentProduct));
    if (choices.length === 0) return null;

    const emptyConfigCode = getEmptyConfigCode(SmartNumberDescriptor.MountingKit, smartNumberDescription);
    if (emptyConfigCode) {
        const resetMountingKitChoice = mountingKitsToChoices([
            {
                configCode: emptyConfigCode,
                ceilingLabel: t("no_mounting_kit"),
                sku: "",
                description: null,
            },
        ]);

        choices.unshift(...resetMountingKitChoice);
    }

    if (choices.length === 0) return null;

    return choices;
}
